import gql from 'graphql-tag';
import { CommentFragments } from './comment.fragments';

export class CommentMutations {
  static create = gql`
    mutation CreateComment($payload: CommentInput!) {
      createContextualComment(payload: $payload) {
        ...commentFragment
      }
    }
    ${CommentFragments.comment}
  `;

  static update = gql`
    mutation UpdateComment($payload: UpdateCommentInput!) {
      updateContextualComment(payload: $payload)
    }
  `;
}
